/**
 * @file Input component for resources input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
import { OverlayService } from '../../../core/overlay.service';
import { AlertsService } from '../../../core/alerts.service';
/**
 * Class for the resources input component
 */
var InputReadByComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputReadByComponent, _super);
    /**
     * Constructs a InputReadbyComponent.
     */
    function InputReadByComponent(overlayService, alertsService) {
        var _this = _super.call(this) || this;
        _this.overlayService = overlayService;
        _this.alertsService = alertsService;
        /** Number of resources visible in view */
        _this.visibleRecipients = 3;
        return _this;
    }
    /**
     * Open any given entity in the app
     * @param entity The entity to open
     */
    InputReadByComponent.prototype.openEntity = function ($event, entity) {
        // Stop event bubbling
        $event.stopPropagation();
        if (!entity) {
            return;
        }
        // Go to entity
        if (!this.overlayService.goToEntity(entity)) {
            this.alertsService.createAlert('warning', 'APP.LISTS.CAN_NOT_GO_TO_ENTITY');
        }
    };
    InputReadByComponent.prototype.selection = function () {
        return (this.value ? this.value.slice(0, this.visibleRecipients) : []);
    };
    return InputReadByComponent;
}(InputBase));
export { InputReadByComponent };
